import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
}

export const Root = styled.div`
  font-family: Roboto;
  padding: 0px 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  padding: 5px;
  gap: 7px;
`;

export const Label = styled.div`
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #fff;
`;